import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material/update-status',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material/create',
    method: 'post',
    data: data
  })
}

export function generateCode(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material/generate-code',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material/update',
    method: 'put',
    data: data
  })
}

export function getMasterMaterialList() {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material/common-list',
    method: 'get'
  })
}





// WEBPACK FOOTER //
// ./src/api/master_material.js